import type { ServicePackage } from "./model";

export const servicePackages: ServicePackage[] = [
  {
    id: "sketch",
    name: "Bản Phác",
    tagline: "Đủ để nhìn ra hướng đi",
    price: 1200000,
    leadTime: "2–3 ngày mô phỏng",
    deliverables: [
      "01 layout 2D",
      "Danh mục cây–chậu",
      "Dự toán theo dòng",
      "Lịch chăm 4 tuần",
    ],
  },
  {
    id: "balanced",
    name: "Vừa Vặn",
    tagline: "Một vòng chỉnh để thật sự vừa nhà",
    price: 2400000,
    leadTime: "4–5 ngày mô phỏng",
    featured: true,
    deliverables: [
      "Mọi thứ trong Bản Phác",
      "01 vòng chỉnh",
      "Phối màu và vật liệu",
      "Checklist lắp đặt",
      "Cuộc gọi 30 phút giả lập",
    ],
  },
  {
    id: "complete",
    name: "Trọn Góc",
    tagline: "Từ phương án đến ngày bàn giao",
    price: 4800000,
    leadTime: "7–10 ngày mô phỏng",
    deliverables: [
      "Mọi thứ trong Vừa Vặn",
      "Khảo sát giả lập",
      "Điều phối lắp đặt cơ bản",
      "Bàn giao hướng dẫn chăm",
    ],
  },
];
